import React from 'react'
import * as styles from "../styles/hero.module.css"
import CarouselComponentHero from './CarouselComponentHero'
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';


export default function Hero() {
    const breakpoints = useBreakpoint();

    if (breakpoints.mobile) {
        return (
            <section className={styles.heroSM}>
                <div>
                    <CarouselComponentHero />

                    <div className={styles.heroContentMobile}>
                        <div className={styles.heroContentLeftMobile}>
                            <div className={styles.heroContentLeftBox}>
                                <h1>Geekay Esports</h1>
                                <h2>The best in the region</h2>
                                {/* <center>
                                    <Link className={styles.heroButton} to="/about">About Us</Link>
                                </center> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    } else if (breakpoints.tablet) {
        return (
            <section className={styles.heroSM}>
                <div>
                    <CarouselComponentHero />

                    <div className={styles.heroContentSM}>
                        <div className={styles.heroContentLeftTablet}>
                            <div className={styles.heroContentLeftBox}>
                                <h1>Geekay Esports</h1>
                                <h2>The best in the region</h2>
                                {/* <center>
                                    <Link className={styles.heroButton} to="/about">About Us</Link>
                                </center> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    } else if (breakpoints.sm) {
        return (
            <section className={styles.heroSM}>
                <div>
                    <CarouselComponentHero />

                    <div className={styles.heroContentSM}>
                        <div className={styles.heroContentLeftSM}>
                            <div className={styles.heroContentLeftBox}>
                                <h1>Geekay Esports</h1>
                                <h2>The best in the region</h2>
                                {/* <center>
                                    <Link className={styles.heroButton} to="/about">About Us</Link>
                                </center> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    } else if (breakpoints.m1) {
        return (
            <section className={styles.hero}>
                <div>
                    <CarouselComponentHero />

                    <div className={styles.heroContentM1}>
                        <div className={styles.heroContentLeftM1}>
                            <div className={styles.heroContentLeftBox}>
                                <h1>Geekay Esports</h1>
                                <h2>The best in the region</h2>
                                {/* <center>
                                    <Link className={styles.heroButton} to="/about">About Us</Link>
                                </center> */}
                            </div>
                        </div>
                        <div className={styles.heroContentRightM1}>
                            <p>
                            The undefeated Geekay Esports League of Legends team have already won the Razer Invitational 2021 ME and are now competing in Intel Arabia Cup which began on 25th May 2021 and will end on the 9th of October.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        )
    } else if (breakpoints.m) {
        return (
            <section className={styles.hero}>
                <div>
                    <CarouselComponentHero />

                    <div className={styles.heroContentM}>
                        <div className={styles.heroContentLeft}>
                            <div className={styles.heroContentLeftBox}>
                                <h1>Geekay Esports</h1>
                                <h2>The best in the region</h2>
                                {/* <center>
                                    <Link className={styles.heroButton} to="/about">About Us</Link>
                                </center> */}
                            </div>
                        </div>
                        <div className={styles.heroContentRightM}>
                            <p>
                            The undefeated Geekay Esports League of Legends team have already won the Razer Invitational 2021 ME and are now competing in Intel Arabia Cup which began on 25th May 2021 and will end on the 9th of October.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        )
    } else if (breakpoints.l) {
        return (
            <section className={styles.hero}>
                <div>
                    <CarouselComponentHero />

                    <div className={styles.heroContentL}>
                        <div className={styles.heroContentLeft}>
                            <div className={styles.heroContentLeftBox}>
                                <h1>Geekay Esports</h1>
                                <h2>The best in the region</h2>
                                {/* <center>
                                    <Link className={styles.heroButton} to="/about">About Us</Link>
                                </center> */}
                            </div>
                        </div>
                        <div className={styles.heroContentRightL}>
                            <p>
                            The undefeated Geekay Esports League of Legends team have already won the Razer Invitational 2021 ME and are now competing in Intel Arabia Cup which began on 25th May 2021 and will end on the 9th of October.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        )
    } else {
        return (
            <section className={styles.hero}>
                <div>
                    <CarouselComponentHero />

                    <div className={styles.heroContent}>
                        <div className={styles.heroContentLeft}>
                            <div className={styles.heroContentLeftBox}>
                                <h1>Geekay Esports</h1>
                                <h2>The best in the region</h2>
                                {/* <center>
                                    <Link className={styles.heroButton} to="/about">About Us</Link>
                                </center> */}
                            </div>
                        </div>
                        <div className={styles.heroContentRight}>
                            <p>
                            The undefeated Geekay Esports League of Legends team have already won the Razer Invitational 2021 ME and are now competing in Intel Arabia Cup which began on 25th May 2021 and will end on the 9th of October.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
